import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IoStorefront } from "react-icons/io5";
import { MdDeliveryDining } from "react-icons/md";
import { useServiceMode } from "../helpers/UseServiceMode";

export default function ServiceModePopup({
    isOpen,
    onClose,
    accentColor = "#ff5b5b",
    note = "*Teslimat ücreti ile birlikte fiyatlar da güncellenecektir",
}) {
    const { t, i18n } = useTranslation("translation", { keyPrefix: "servicesMode" });
    const mode = useServiceMode();

    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e) => e.key === "Escape" && onClose?.();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            className="smp-backdrop"
            style={{ zIndex: 1000, ["--smp-accent"]: accentColor }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="smp-title"
        >
            <div className="smp-card">
                <button
                    className="smp-close"
                    aria-label="Kapat"
                    type="button"
                    onClick={onClose}
                >
                    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                        <path
                            d="M18.3 5.7a1 1 0 0 0-1.4-1.4L12 9.17 7.1 4.3a1 1 0 1 0-1.4 1.4L10.83 12l-5.13 5.1a1 1 0 1 0 1.4 1.4L12 14.83l4.9 4.87a1 1 0 0 0 1.4-1.4L13.17 12l5.13-5.1Z"
                            fill="currentColor"
                        />
                    </svg>
                </button>

                <div className="smp-options">
                    <button
                        className={`smp-option ${mode === "pickup" ? "is-selected" : ""}`}
                        type="button"
                        onClick={() => {
                            try { localStorage.setItem("serviceMode", "pickup"); } catch { }
                            window.dispatchEvent(new Event("serviceModeChanged"));
                            onClose();
                        }}
                    >
                        <span className="smp-icon">
                            <IoStorefront size={96} color={accentColor} />
                        </span>
                        <span id="smp-title" className="smp-text">
                            {t("pickup")}
                        </span>
                    </button>

                    <button
                        className={`smp-option ${mode === "delivery" ? "is-selected" : ""}`}
                        type="button"
                        onClick={() => {
                            try { localStorage.setItem("serviceMode", "delivery"); } catch { }
                            window.dispatchEvent(new Event("serviceModeChanged"));
                            onClose();
                        }}
                    >
                        <span className="smp-icon">
                            <MdDeliveryDining size={96} color={accentColor} />
                        </span>
                        <span className="smp-text">{t("delivery")}</span>
                    </button>
                </div>

                {note && <p className="smp-note">{t("deliveryNote")}</p>}
            </div>
        </div>
    );
}
